exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2vLk7,._GdKl{height:18px;border-radius:2px;font-size:10px;line-height:12px;text-align:center;text-transform:uppercase;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#000!important}._1UkdP{position:absolute;right:5px;top:5px}._2vLk7:hover,._GdKl:hover{color:#000!important}._GdKl{width:35px;background:-webkit-gradient(linear,left bottom,left top,from(rgba(255,217,6,.6)),to(rgba(255,217,6,.6))),#fff;background:-o-linear-gradient(bottom,rgba(255,217,6,.6),rgba(255,217,6,.6)),#fff;background:linear-gradient(0deg,rgba(255,217,6,.6),rgba(255,217,6,.6)),#fff;font-weight:600}._2vLk7{width:38px;background:#ffd906;padding:3px}._2vLk7 svg{margin-right:3px}", ""]);

// exports
exports.locals = {
	"vip": "_2vLk7",
	"top": "_GdKl",
	"position-topRight": "_1UkdP",
	"position-none": "_1UCZh"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/AdvertLabel/AdvertLabel.css
// module id = 1712
// module chunks = 15 20 21 23 32 33 38